import moment from "moment";

export default function calculateDaysFromNow(date?: string) {
    if (!date) return 0;
    const now = moment();
    const targetDate = moment(date);
    return now.diff(targetDate, "days");
}
